export default __webpack_public_path__ + "static/media/bank-account.a81a729c.svg";